/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.about", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: true,
                rows: 0,
                pauseOnFocus: false, 
                pauseOnHover: false
            }
        },

        _create: function () {
            this.wrap = this.element;
            this.timer

            var slickOpts = Object.assign(this.options.slickOptions, {
                responsive: [
                    {
                        breakpoint: api.vars.scr.desktop, // tablet view
                        settings: {
                            slidesToShow:2
                        }
                    },
                    {
                        breakpoint: api.vars.scr.tablet, // mobile view
                        settings: {
                            slidesToShow:1
                        }
                    }
                ]
            });
          

            var gal = $('.s-about-us__gal', this.wrap);

            gal.on('init', (slick)=>{
                var dots = $('.slick-dots', $(slick.target))  
                api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
            })
            .slick(slickOpts)
            .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                var dots = $('.slick-dots', $(event.target))
                api.fn.slickDotsFilled(dots, nextSlide)
            })
            

        }

    });
})(jQuery);
